var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0714 16.4307C9.87417 16.2334 9.55438 16.2334 9.35714 16.4307C9.15991 16.6279 9.15991 16.9477 9.35714 17.1449L13.3268 21.1146L22.3804 12.0825C22.5833 11.8802 22.5809 11.5508 22.3752 11.3514C22.1741 11.1564 21.8538 11.1589 21.6557 11.357L13.3268 19.686L10.0714 16.4307Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e72253aa4adf4724fba4e280d84ad6fe.svg";
export { ForwardRef as ReactComponent };